import OrderHistoryPage from '../../features/student/OrderHistoryPage';

function OrderHistory() {
    return (
        <OrderHistoryPage />
    )
}

export default OrderHistory;